import { Injectable } from '@angular/core';
import { Platform } from '@ionic/angular';
import { BehaviorSubject, Observable, from, of } from 'rxjs';
import { take, map, switchMap } from 'rxjs/operators';
import { HttpClient, HttpHeaders, HttpRequest, HttpEvent } from '@angular/common/http';
import { Router } from '@angular/router';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ConnectionService {

  private _url = environment.baseUrl;

  private quoteList = new BehaviorSubject<any>([]);

  quoteListArray = this.quoteList.asObservable();

  quoteListChange(quoteListData: any) {
    this.quoteList.next(quoteListData);
  }

  private healthQuoteList = new BehaviorSubject<any>([]);
  private vehicleQuoteList = new BehaviorSubject<any>([]);

  healthQuoteListArray = this.healthQuoteList.asObservable();
  vehicleQuoteListArray = this.vehicleQuoteList.asObservable();

  healthQuoteListChange(quoteListData: any) {
    this.healthQuoteList.next(quoteListData);
  }
  vehicleQuoteListChange(quoteListData: any) {
    this.vehicleQuoteList.next(quoteListData);
  }
  constructor(
    private http: HttpClient,
    private router: Router,
  ) { }

  //icici quote - public api
  getIciciQuotation(data): Observable<any> {
    return this.http.post(`${this._url}/user/public/icici/quote`, data);
  }

  //icici quote - private api
  getIciciQuotationPvt(data): Observable<any> {
    return this.http.post(`${this._url}/user/private/icici/quote`, data);
  }

  //hdfc quote - public api
  getHdfcQuotation(data): Observable<any> {
    return this.http.post(`${this._url}/user/public/insurance/hdfc/quote`, data);
  }

  //hdfc quote - private api
  getHdfcQuotationPvt(data): Observable<any> {
    return this.http.post(`${this._url}/user/private/insurance/hdfc/quote`, data);
  }

  //save finalQuote to user by email
  saveFinalQuotation(data): Observable<any> {
    return this.http.post(`${this._url}/user/private/insurance/finalQuote/save`, data);
  }

  //get quotes by userId
  // getQuotesByUserId(userId): Observable<any> { //for direct ref
    // return this.http.get(`${this._url}/user/private/getQuote/` + userId); //for direct ref
  // getQuotesByUserId(): Observable<any> {
  //   return this.http.get(`${this._url}/user/private/getQuote`);
  // }
  getQuotesByUserId(data): Observable<any> {
    return this.http.post(`${this._url}/user/private/getQuote`, data);
  }

  //Get Order Id for proposal form/Application form
  getApplicationOrderId(data): Observable<any> {
    return this.http.post(`${this._url}/user/private/insurance/order`, data);
  }

  //post icici proposal/application form
  postIciciApplicationForm(data): Observable<any> {
    return this.http.post(`${this._url}/user/private/insurance/application`, data);
  }

  //generate billdesk data - first premium payment
  generateBilldeskData(data): Observable<any> {
    return this.http.post(`${this._url}/user/private/generate-billdesk-data`, data);
  }

  //generate billdesk-si data - first premium payment for Monthly SI
  generateBilldeskSIData(data): Observable<any> {
    return this.http.post(`${this._url}/user/private/generate-billdesk-data-si`, data);
  }

  //redirect to billdesk - first premium payment
  sendRedirectRequest(data): Observable<any> {
    return this.http.post(data.url + '?msg=' + data.msg, null);
  }

  //get insurance transaction application details by user id
  // getTransactionDetails(userId): Observable<any> { //for direct ref
  //   return this.http.get(`${this._url}/user/private/get-insurance-application/` + userId); //for direct ref
  getTransactionDetails(data): Observable<any> {
    return this.http.get(`${this._url}/user/private/get-insurance-application?policyStatus=${data.policyStatus}&policyType=${data.policyType}`);
  }

  //get Reverse feed api to check status of application
  getIcIcApplicationStatus(data): Observable<any> {
    return this.http.get(`${this._url}/user/private/get-reverse-feed?appNumber=` + data);
  }

  //save incomplete icici application data
  saveIncompleteICICIAppData(data): Observable<any> {
    return this.http.post(`${this._url}/user/private/insurance/application/save`, data);
  }

  //get incomplete icici application data by user id
  // getIncompleteICICIAppData(userId): Observable<any> { //for direct ref
  //   return this.http.get(`${this._url}/user/private/get-incomplete-application/${userId}`) //for direct ref
  getIncompleteICICIAppData(): Observable<any> {
    return this.http.get(`${this._url}/user/private/get-incomplete-application`)
  }

  //download policy
  IcIcpolicydownload(data): Observable<any> {
    return this.http.post(`${this._url}/user/private/policy-doc-download?applicationKey=${data}`,null);
  }

  //sharescreen
  // Adminaccess(data): Observable<any>{
  //   return this.http.post(`${this._url}/user/private/changeAccess`,data);
  // }
  Adminaccess(bln): Observable<any>{
    return this.http.post(`${this._url}/user/private/changeAccess?isAdvisorAccessible=`+bln, null);
  }

  //icic-app-tracker-api
  IcIcAppTracker(data): Observable<any>{
    return this.http.post(`${this._url}/user/private/get-partner-app-tracker`,data);
  }

  //save other basic details of user
  saveBasicUserDetails(data): Observable<any>{
    return this.http.post(`${this._url}/user/private/update-user-status`,data);
  }

  //sendOTP for mobile verification
  // sendOtp(mobileNo, userId): Observable<any>{ //for direct ref
  //   return this.http.get(`${this._url}/user/private/sendOtp/${mobileNo}/${userId}`); //for direct ref
  sendOtp(mobileNo): Observable<any>{
    return this.http.get(`${this._url}/user/private/sendOtp/${mobileNo}`);
  }

  //getOTP for mobile verification
  // resendOtp(mobileNo, userId): Observable<any>{ //for direct ref
  //   return this.http.get(`${this._url}/user/private/resendOtp/${mobileNo}/${userId}`); //for direct ref
  resendOtp(mobileNo): Observable<any>{
    return this.http.get(`${this._url}/user/private/resendOtp/${mobileNo}`);
  }

  //verify otp for login mobile verification
  verifyOtp(data): Observable<any>{
    return this.http.post(`${this._url}/user/private/verifyOtp/signUp`,data);
  }

  //verify otp for icici application form
  verifyOtpIcici(data): Observable<any>{
    return this.http.post(`${this._url}/user/private/verifyOtp`,data);
  }

  //address api
  // getaddress(email):Observable<any>{ //for direct ref
  //   return this.http.get(`${this._url}/user/private/get-user-address/${email}`); //for direct ref
  getaddress():Observable<any>{
    return this.http.get(`${this._url}/user/private/get-user-address`);
  }

  //edit address
  // editaddress(email, address):Observable<any>{ //for direct ref
  //   return this.http.post(`${this._url}/user/private/edit-user-address/${email}/${address}`, null); //for direct ref
  editaddress(address):Observable<any>{
    return this.http.post(`${this._url}/user/private/edit-user-address/${address}`, null);
  }

  //resttoken
  resetpassword(data): Observable<any> {
    return this.http.post(`${this._url}/user/public/reset-password`,data)
  }

  //forgotpassword
  forgotpassword(data): Observable<any>{
    return this.http.post(`${this._url}/user/public/forgot-password?email=${data}`, null)
  }

  //name of organisationlist
  getorganisationname(data):Observable<any>{
    return this.http.get(`${this._url}/user/private/getOrganizationName/${data}`)
  }

  //profile pic update
  updateProfilePic(data): Observable<any> {
    let formData = new FormData();
    formData.append('profileImage', data.profileImage);
    // formData.append('email', data.email); //for direct ref
    return this.http.post(`${this._url}/user/private/profile-image`,  formData, {
      reportProgress: true,
      responseType: 'text'
    });
  }

  changePassword(userDetails): Observable<any> {
    return this.http.post(`${this._url}/user/private/change-password`, userDetails);
  }

  //ingenico ecs mandate get bank list
  getEcsBankList(type): Observable<any> {
    return this.http.get(`${this._url}/user/private/fetch/all/emandatebank/Net Banking`);
  }
  
  //ingenico ecs mandate post data and get hash/token
  getEcsHash(data): Observable<any> {
    return this.http.post(`${this._url}/user/private/emandate-history`, data);
  }
  
  //ckyc form submission
  postHdfcCkyc(data):Observable<any> {
    return this.http.post(`${this._url}/user/private/insurance/hdfc/ckyc`, data);
  }

  //hdfc form submit
  postHdfcApp(data):Observable<any>{
    return this.http.post(`${this._url}/user/private/insurance/hdfc/submitApplication`, data);
  }

  //Care quote form
  postCareQuoteForm(data):Observable<any>{
    return this.http.post(`${this._url}/user/public/insurance/care/quote`,data);
  }

   //Care quote form
   postCareQuoteFormPvt(data):Observable<any>{
    return this.http.post(`${this._url}/user/private/insurance/care/quote`,data);
  }
  
  //public quote email trigger
  publicQuoteEmailTrigger(data):Observable<any>{
    return this.http.post(`${this._url}/user/public/send/email/quote`, data);
  }

  //hdfc application status
  getHdfcApplicationStatus(data):Observable<any>{
    return this.http.post(`${this._url}/user/private/insurance/hdfc/status?applicationNumber=${data.applicationNumber}`, null);
  }

  //submit care application data
  postCareSubmitApplication(data):Observable<any>{
    return this.http.post(`${this._url}/user/private/insurance/care/submitApplication`,data)
  }

  //submit care top-up
  postCareTopUp(data):Observable<any>{
    return this.http.post(`${this._url}/user/private/care/top-up/application-submit`,data)
  }

  //get care pincode
  getPincode(data):Observable<any>{
    return this.http.get(`${this._url}/user/public/care/pin/${data}`)
  }

  //care application status
  postCareStatus(data):Observable<any>{
    return this.http.post(`${this._url}/user/private/insurance/care/getPolicyStatus?proposalNum=${data}`, null);
  }

  //star health FHO quote api
  getFHOQuote(data): Observable<any> {
    return this.http.post(`${this._url}/user/public/insurance/familyHealthOptima/quote`, data);
  }

  //star health MCI quote api
  getMCIQuote(data): Observable<any> {
    return this.http.post(`${this._url}/user/public/insurance/mediIndividual/quote`, data);
  }

  //star health RCF quote api
  getRCFQuote(data): Observable<any> {
    return this.http.post(`${this._url}/user/public/insurance/readCarpet/floater/quote`, data);
  }

  //star health RCI quote api
  getRCIQuote(data): Observable<any> {
    return this.http.post(`${this._url}/user/public/insurance/readCarpet/individual/quote`, data);
  }

  //star health quote api public
  getStarhealthQuote(data): Observable<any> {
    return this.http.post(`${this._url}/user/public/insurance/star-health/quote`, data)
  }
  getStarhealthTopUpQuote(data): Observable<any> {
    return this.http.post(`${this._url}/user/public/insurance/top-up/quote`, data)
  }
  getStarhealthTopUpQuotePvt(data): Observable<any> {
    return this.http.post(`${this._url}/user/private/star-health/top-up/quote`, data)
  }
  getCarehealthTopUpQuotePvt(data): Observable<any>{
    return this.http.post(`${this._url}/user/private/care/top-up/quote`, data)
  }
  //star health quote api pvt
  getStarhealthQuotePvt(data): Observable<any> {
    return this.http.post(`${this._url}/user/private/insurance/star-health/quote`, data)
  }
  //star city code
  getStarCityCode(data): Observable<any>{
    return this.http.get(`${this._url}/user/private/star-health/city-area?pinCode=${data}`, data);
  }
  //star area code
  getStarAreaCode(data1,data2): Observable<any>{
    return this.http.get(`${this._url}/user/private/star-health/city-area?pinCode=${data2}&cityId=${data1}`);
  }

  //star policy status api
  getStarPolicyStatus(referenceId): Observable<any>{
    return this.http.get(`${this._url}/user/private/star-health/policy-status?referenceId=${referenceId}`)
  }

  //star policy document download api
  downloadStarPolicyDoc(policyNo): Observable<any>{
    return this.http.get(`${this._url}/user/private/insurance/star/policyPdfDownload?referenceId=${policyNo}`)
  }

  //Cashless Hospital
  //care application status
  postCashLessHospital(data):Observable<any>{
    return this.http.post(`${this._url}/user/public/care/hospital-list?page=0&size=50&sort=&order=ASCENDING&hospitalName=${data.hospitalname}&city=${data.city}&district=${data.district}&state=${data.state}&pincode=${data.pincode}`, null);
  }

  //icici negative quote list api
  getIciciNegativePincode(pincode): Observable<any>{
    return this.http.get(`${this._url}/user/public/insurance/icici/get-negative-pincode?lomPincode=${pincode}`);
  }

  //hdfc policy document download api
  getHdfcPolicyDoc(policyNo): Observable<any> {
    return this.http.get(`${this._url}/user/private/insurance/hdfc/download-policy-doc?policyNo=${policyNo}`);
  }

  //health public quote email trigger
  healthPublicQuoteEmailTrigger(data):Observable<any>{
    return this.http.post(`${this._url}/user/public/health/send-email-quote`, data);
  }
  //Top up public quote email trigger
  topUpPublicQuoteEmailTrigger(data):Observable<any>{
    return this.http.post(`${this._url}/user/public/top-up/send-email-quote`, data);
  }

  vehiclePublicQuoteEmailTrigger(data):Observable<any>{
    return this.http.post(`${this._url}/user/public/vehicle/send-email-quote`, data);
  }

  //download care policy document
  downloadCarePolicyDoc(policyNo): Observable<any> {
    return this.http.post(`${this._url}/user/private/insurance/care/policyPdfDownload?policyNum=${policyNo}`, null);
  }
  
  starSubmitApplication(data):Observable<any>{
    return this.http.post(`${this._url}/user/private/insurance/star-health/submit-application`,data)
  }
  starTopSubmitApplication(data):Observable<any>{
    return this.http.post(`${this._url}/user/private/star-health/top-up/application-submit`,data)
  }
  //vechile - car api's
  //get car vehicle model master list
  getCarModels(data): Observable<any>{
    return this.http.get(`${this._url}/user/public/vehicle/fw/models?brand=${data.brand}&fuelType=${data.fuelType}`);
  }

  //get car rto master list
  getCarRto(city): Observable<any>{
    return this.http.get(`${this._url}/user/public/icici-lombard/rto-master?location=${city}`);
  }

  //public vehicle quote api - car
  getVehicleQuotePublic(data): Observable<any> {
    return this.http.post(`${this._url}/user/public/insurance/vehicle/quote`, data);
  }

  getVehicleQuotePrivate(data): Observable<any> {
    return this.http.post(`${this._url}/user/private/insurance/icici-lombard/quote`, data);
  }
  lombardSubmitApplication(data):Observable<any>{
    return this.http.post(`${this._url}/user/private/insurance/icici-lombard/submit-application`,data);
  }
  lombardGetPin(data):Observable<any>{
    return this.http.get(`${this._url}/user/private/insurance/icici-lombard/city-state-pincode?pincode=${data}`)
  }

  //download policy doc api for lombard - general insurance
  getPolicyDocLombard(data): Observable<any> {
    return this.http.post(`${this._url}/user/private/insurance/icici-lombard/policyCertificateDownload`, data);
  }

  // health generic quote api
  getHealthQuotes(data): Observable<any> {
    return this.http.post(`${this._url}/user/public/insurance/health/quote`, data);
  }
  
  breakinSubmit(data):Observable<any>{
    return this.http.post(`${this._url}/user/private/insurance/lombard/create-breakin`,data)
  }
  createTransaction(data):Observable<any>{
    return this.http.post(`${this._url}/user/private/insurance/lombard/create-transaction?applicationNumber=${data}`,null)
  }

  // care ckyc and ekyc check
  checkCareKYC(data): Observable<any> {
    return this.http.post(`${this._url}/user/private/insurance/care/kyc`, data)
  }

  // fetch care ekyc details
  fetchCareEkycDetails(data): Observable<any> {
    return this.http.post(`${this._url}/user/private/insurance/care/kyc/aadharDetails?requestId=`+data, null);
  }

  // upload care ovd kyc documents
  uploadCareOvdKycDocs(data): Observable<any> {
    let formData = new FormData();
    formData.append('ekycDocuments', data.docFile);
    return this.http.post(`${this._url}/user/private/insurance/care/kyc/uploadDocument?proposalNumber=${data.proposalNo}&docType=${data.docType}`, formData, {
      reportProgress: true,
      responseType: 'text'
    })
  }

  //star search ckyc api using pan
  searchStarCkyc(data): Observable<any> {
    return this.http.post(`${this._url}/user/private/insurance/star/ckyc?panNumber=`+data, null);
  }

  //star get ckyc Reference Number
  getStarCkycRefNumber(data, proofFiles): Observable<any> {
    let formData = new FormData();
    let blob = new Blob([JSON.stringify(data)], {type: "application/json"})
    // formData.append('userDetails', JSON.stringify(data));
    formData.append('userDetails', blob);
    if(proofFiles.proofPhoto) {
      formData.append('photoCopy', proofFiles.proofPhoto);
      // formData.append('proofDocumentFull', proofFiles.proofSingleFile);
      if(proofFiles.proofSingleFile) {
        formData.append('proofDocumentFull', proofFiles.proofSingleFile);
      } 
      else {
      // if(proofFiles.proofFrontFile && proofFiles.proofBackFile){
        formData.append('proofDocumentFront', proofFiles.proofFrontFile);
        formData.append('proofDocumentBack', proofFiles.proofBackFile);
      }
    }
    return this.http.post(`${this._url}/user/private/insurance/star/ckyc/reference`, formData)
    // {
    //   // headers: { 'Content-Type': undefined },
    //   // reportProgress: true,
    //   // responseType: 'text'
    // }
  }

  // to verify the google reCaptcha
  checkRecaptchaResponse(data): Observable<any> {
    return this.http.post(`${this._url}/user/public/captcha-verify?response=${data}`, null);
  }

  // lombard general insurance initiate ckyc
  searchLombardVehicleCkyc(data): Observable<any> {
    return this.http.post(`${this._url}/user/private/insurance/lombard/ckyc`, data);
  }
  
  // lomabrd general insurance ovd docs upload
  lombardVehicleOvdUpload(data): Observable<any> {
    let formData = new FormData();
    formData.append('correlationId', new Blob([data.correlationId], {type: "application/hal+json"}));
    formData.append('mobileNumber', new Blob([data.mobile], {type: "application/hal+json"}));
    formData.append('email', new Blob([data.email], {type: "application/hal+json"}));
    formData.append('pepFlag', new Blob([data.pepFlag], {type: "application/hal+json"}));
    formData.append('isSameDoc', new Blob([data.isSameDoc], {type: "application/hal+json"}));
    if(!data.isSameDoc) {
      formData.append('poiDocumentType', new Blob([data.poiDocumentType], {type: "application/hal+json"}));
      formData.append('poiDocument', data.poiDocument);
      formData.append('poaDocumentType', new Blob([data.poaDocumentType], {type: "application/hal+json"}));
      formData.append('poaDocument', data.poaDocument);
    } else {
      formData.append('poaDocumentType', new Blob([data.poaDocumentType], {type: "application/hal+json"}));
      formData.append('poaDocument', data.poaDocument);
    }
    return this.http.post(`${this._url}/user/private/insurance/lombard/ckyc/upload-document`, formData);
  }
}
